import { Box, Stack, Typography } from '@mui/material';

import Logo from '../logo';

const COVERS = [ 'java', 'kafka', 'sql', 'docker' ];

/** The side of the sign-in screen that says what KataQuiz is: the logo, a few course covers and the promise. */
export function AuthShowcase() {
    return (
        // Centred vertically like the sign-in card beside it, so both halves line up on tall screens
        <Stack spacing={ 3.5 } justifyContent="center" sx={ {
            width: 620, flexShrink: 0, boxSizing: 'border-box', px: 6, py: 5, bgcolor: '#FFFFFF', borderRight: '1px solid #E3E8EE',
            display: { xs: 'none', md: 'flex' },
        } }>
            <Logo/>

            <Box sx={ { display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 2 } }>
                { COVERS.map((cover) => (
                    <Box key={ cover } component="img" src={ `/assets/images/covers/${ cover }.svg` } alt=""
                         sx={ { width: '100%', aspectRatio: '4 / 3', objectFit: 'cover', borderRadius: '16px', display: 'block', border: '1px solid #E3E8EE' } }/>
                )) }
            </Box>

            <Stack spacing={ 1 }>
                <Typography component="h2" variant="inherit" sx={ { fontSize: 24, lineHeight: '31px', fontWeight: 800, letterSpacing: '-0.01em' } }>
                    Don't let your knowledge gather dust.
                </Typography>
                <Typography sx={ { fontSize: 15, lineHeight: '23px', color: '#4F5B67' } }>
                    Refresh what you've already learned every day and keep learning new things, so you're ready for interviews, certifications and effective work.
                </Typography>
            </Stack>
        </Stack>
    );
}
